export var IdBigCharacter;
(function (IdBigCharacter) {
    IdBigCharacter["Empty"] = "";
    IdBigCharacter["MonicaLeftSide"] = "big-character_monica1";
    IdBigCharacter["TessaLeftSide"] = "big-character_tessa";
    IdBigCharacter["RitaHappy"] = "big-character_ritaHappy";
    IdBigCharacter["GeorgeHappy"] = "big-character_georgeHappy";
    IdBigCharacter["George"] = "big-character_george";
    IdBigCharacter["Monica"] = "big-character_monica";
    IdBigCharacter["MontgomeryPoints"] = "big-character_montgomeryPoints";
    IdBigCharacter["TessaHappy"] = "big-character_tessaHappy";
    // themed events characters
    IdBigCharacter["BigCharacter_Montgomery"] = "big-character_montgomery";
    IdBigCharacter["BigCharacter_Asian"] = "big-character_asian";
    IdBigCharacter["BigCharacter_Camping"] = "big-character_camping";
    IdBigCharacter["BigCharacter_Claire"] = "big-character_claire";
    IdBigCharacter["BigCharacter_Daniel"] = "big-character_daniel";
    IdBigCharacter["BigCharacter_Eva"] = "big-character_eva";
    IdBigCharacter["BigCharacter_Eva_FortuneTeller"] = "big-character_evaFortuneTeller";
    IdBigCharacter["BigCharacter_Fairytale"] = "big-character_fairytale";
    IdBigCharacter["BigCharacter_FarmCup"] = "big-character_farmCup";
    IdBigCharacter["BigCharacter_George"] = "big-character_george";
    IdBigCharacter["BigCharacter_GeorgeHappy"] = "big-character_georgeHappy";
    IdBigCharacter["BigCharacter_Halloween"] = "big-character_halloween";
    IdBigCharacter["BigCharacter_Hawaii"] = "big-character_hawaii";
    IdBigCharacter["BigCharacter_Jack"] = "big-character_jack";
    IdBigCharacter["BigCharacter_JackHalloween"] = "big-character_jackHalloween";
    IdBigCharacter["BigCharacter_JackMIB"] = "big-character_jackMIB";
    IdBigCharacter["BigCharacter_James"] = "big-character_james";
    IdBigCharacter["BigCharacter_Jim"] = "big-character_jim";
    IdBigCharacter["BigCharacter_JimHalloween"] = "big-character_jimHalloween";
    IdBigCharacter["BigCharacter_Johnny"] = "big-character_johnny";
    IdBigCharacter["BigCharacter_Lana"] = "big-character_lana";
    IdBigCharacter["BigCharacter_LanaWinter"] = "big-character_lanaWinter";
    IdBigCharacter["BigCharacter_Lester"] = "big-character_lester";
    IdBigCharacter["BigCharacter_Lilly"] = "big-character_lilly";
    IdBigCharacter["BigCharacter_Monica"] = "big-character_monica";
    IdBigCharacter["BigCharacter_Monica1"] = "big-character_monica1";
    IdBigCharacter["BigCharacter_Nils"] = "big-character_nils";
    IdBigCharacter["BigCharacter_Rita"] = "big-character_rita";
    IdBigCharacter["BigCharacter_RitaHappy"] = "big-character_ritaHappy";
    IdBigCharacter["BigCharacter_Rod"] = "big-character_rod";
    IdBigCharacter["BigCharacter_Tessa"] = "big-character_tessa";
    IdBigCharacter["BigCharacter_TessaHappy"] = "big-character_tessaHappy";
    IdBigCharacter["BigCharacter_TessaOktoberfest"] = "big-character_tessaOktoberfest";
    IdBigCharacter["BigCharacter_TessaWinter"] = "big-character_tessaWinter";
    IdBigCharacter["BigCharacter_Ufo"] = "big-character_ufo";
    IdBigCharacter["BigCharacter_Vicky"] = "big-character_vicky";
    IdBigCharacter["BigCharacter_Christmas"] = "big-character_tessaWinter";
    IdBigCharacter["BigCharacter_Easter"] = "big-character_lilly";
    IdBigCharacter["BigCharacter_FoodTruck"] = "big-character_claire";
    IdBigCharacter["BigCharacter_DanielWedding"] = "big-character_danilelWedding";
    IdBigCharacter["BigCharacter_LillyWedding"] = "big-character_lillyWedding";
    IdBigCharacter["BigCharacter_EvaCharity"] = "big-character_evaCharity";
    IdBigCharacter["BigCharacter_EvaEaster"] = "big-character_evaEaster";
})(IdBigCharacter || (IdBigCharacter = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/big-character/IdBigCharacter.ts
// module id = 133
// module chunks = 3